import colors from '../../tokens/colors';
const tokens = {
    primary: colors.pink500,
    primary10: colors.pink100,
    primary20: colors.pink200,
    primary30: colors.pink400,
    primary40: colors.pink600,
    primary50: colors.pink700,
    secondary: colors.pink500,
    secondary10: colors.pink100,
    secondary20: colors.pink200,
    secondary30: colors.pink400,
    secondary40: colors.pink600,
    secondary50: colors.pink700,
    surface: colors.snow100,
    surface10: colors.snow200,
    surface20: colors.snow300,
    surface30: colors.snow500,
    surface40: colors.snow600,
    surface50: colors.snow900,
    surfaceInverse: colors.black100,
    surfaceInverse10: colors.black900,
    surfaceInverse20: colors.black800,
    surfaceInverse30: colors.black500,
    surfaceInverse40: colors.black400,
    surfaceInverse50: colors.black200,
    textPrimary: colors.pebble900,
    textInversePrimary: colors.snow100,
    state: colors.grey900,
    info: colors.blue500,
    info50: colors.blue50,
    warning: colors.orange500,
    warning50: colors.orange50,
    positive: colors.green500,
    positive50: colors.green50,
    negative: colors.red500,
    negative50: colors.red50,
    white: colors.snow100,
};
export default tokens;
